import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../Table/TableComponent";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Formatter from "../../../Localization/Formatter";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { QuickPaymentDialog } from "../../Partials/Dialog/QuickPaymentDialog";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import Constants from "../../../Action/Constants";
import Time from "../../../Time/Time";
import * as ReactTooltip from "react-tooltip";
import Memo from "../../Partials/Memo/Memo";

class BalanceComponent extends Component {
  protected sliceBy: number;
  protected showAfterUnpaid: number = 10;
  protected selectedCharge: ChargeInterface;
  protected balancePaginatorPath: string;

  public state = {
    slice: this.sliceBy,
    isChargeUlinkPopupOpen: false,
    charge: null,
    anchorEl: null,
    isChargeUnSettlePopupOpen: false,
    unSettleCharge: null,
    isChargeRemovePopupOpen: false,
    chargeToUnSettle: null,
    unitCombinedContracts: [],
    balanceCharges: [],
    cannotDeleteSavingsChargeDialog: false,
    isPayChargePopupOpen: null,
    paymentDateQuickOption: new Date(),
    amountForPayment: "",
    counterpartyIbanForPayment: "",
    firstDateOfStatementPeriodForPayment: new Date(),
    agencyBankAccountIdForPayment: null,
    isNewTaskPopupOpen: false,
    chargeToAddNote: null,
    memoPopupOpen: false
  }

  constructor(public props) {
    super(props);

    if (typeof this.props.contractId !== "undefined") {
      this.balancePaginatorPath = `ContractBalance_${this.props.contractId}`;
    }

    if (typeof this.props.unitId !== "undefined") {
      this.balancePaginatorPath = `UnitBalance_${this.props.unitId}`;

      if (typeof this.props.unitCombinedContracts !== "undefined") {
        this.balancePaginatorPath = `UnitContractsBalance_${this.props.unitId}`;
      }
    }

    if (typeof this.props.propertyId !== "undefined") {
      this.balancePaginatorPath = `PropertyBalance_${this.props.propertyId}`;
    }

    if (typeof this.props.eventId !== "undefined") {
      this.balancePaginatorPath = `EventBalance_${this.props.eventId}`;
    }

    if (typeof this.props.companyId !== "undefined") {
      this.balancePaginatorPath = `CompanyBalance_${this.props.companyId}`;
    }
  }

  public componentWillMount() {
    this.setState({
      unitCombinedContracts: this.props.unitCombinedContracts,
      balanceCharges: this.props.balanceCharges
    }, () => {
      const sliceBy = !!this.state.unitCombinedContracts ?
        this.getVisibleChargesAmount(this.getContractBalanceRows(this.state.unitCombinedContracts)) :
        this.getVisibleChargesAmount(this.getChargesBalanceRows(this.state.balanceCharges));

      this.sliceBy = sliceBy;

      this.setState({
        sliceBy: sliceBy
      });

      const agencyBankAccounts: BankAccountInterface[] = this.getAgencyBankAccounts();

      const defaultBankAccount: BankAccountInterface = agencyBankAccounts.find(bankAccount => {
        return bankAccount.isDefault === true;
      });

      let agencyBankAccountId;

      if (!!defaultBankAccount) {
        agencyBankAccountId = !!defaultBankAccount ? defaultBankAccount.id : null;
      } else {
        agencyBankAccountId = !!agencyBankAccounts[0] ? agencyBankAccounts[0].id : null;
      }

      this.setState({
        agencyBankAccountIdForPayment: agencyBankAccountId
      })
    });
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({
      unitCombinedContracts: nextProps.unitCombinedContracts,
      balanceCharges: nextProps.balanceCharges
    }, () => {
      const sliceBy = !!this.state.unitCombinedContracts ?
        this.getVisibleChargesAmount(this.getContractBalanceRows(this.state.unitCombinedContracts)) :
        this.getVisibleChargesAmount(this.getChargesBalanceRows(this.state.balanceCharges));

      this.sliceBy = sliceBy;

      this.setState({
        sliceBy: sliceBy
      });
    });
  }

  public getVisibleChargesAmount = (chargesRows) => {
    let amountToDisplay: number = 0;

    for (let i = chargesRows.length - 1; i >= 0; i--) {
      if (chargesRows[i].amountPaid < chargesRows[i].amount) {
        amountToDisplay = i + 1 + this.showAfterUnpaid;
        break;
      }

      if (i === 0) {
        amountToDisplay = this.showAfterUnpaid;
        break;
      }
    }

    return amountToDisplay;
  }

  protected openMenu = (event: any, charge: ChargeInterface): void => {
    this.selectedCharge = charge;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public unSettle = (): any => {
    const charge: ChargeInterface = this.state.chargeToUnSettle;

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_UNSETTLE_START,
      payload: {
        chargeId: charge?.id
      },
      onSuccess: () => {
        if (typeof this.props.fetchCharges === "function") {
          this.props.fetchCharges();
        }

        this.setState({ isChargeUnSettlePopupOpen: false, isSaving: false });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public delete = () => {
    const charge = this.state.charge;

    this.props.deleteCharge.call(this, charge);

    this.setState({
      charge: null,
      isChargeUlinkPopupOpen: false
    })
  }

  public closePrompt = () => {
    this.setState({
      isChargeUlinkPopupOpen: false,
      isChargeUnSettlePopupOpen: false
    })
  }

  public deleteCharge = (charge: ChargeInterface): any => {
    if (charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_withdraw") || charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_deposit")) {
      return this.setState({
        isChargeRemovePopupOpen: false,
        cannotDeleteSavingsChargeDialog: true
      });
    }
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_DELETE_START,
      payload: {
        charge: charge
      }
    });
  }

  public showMore = (): void => {
    this.setState({
      slice: this.state.unitCombinedContracts ? this.getContractBalance().length : this.getChargesBalance().length
    });
  }

  public showLess = (): void => {
    this.setState({
      slice: this.sliceBy
    });

    // window.scrollTo(0, 0);
  }

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
      return
    }

    if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isPayable) {
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-pay")}`
    } else if ((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isReceivable) {
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-receive")} `
    } else if (charge?.amountRemaining === charge?.amount && charge?.isPayable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-pay")}`
    } else if (charge?.amountRemaining === charge?.amount && charge?.isReceivable && !charge.isFullyPaid()) {
      status = `${this.trans("status-to-receive")}`
    } else if (charge.isFullyPaid() && charge?.isReceivable) {
      status = `${this.trans("status-received")}`
    } else if (charge.isFullyPaid() && charge?.isPayable) {
      status = `${this.trans("status-amount/paid")}`
    } else {
      status = ""
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {status}
      </span>
    );
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public openMemoPopup = (charge: ChargeInterface) => {
    this.setState({
      chargeToAddNote: charge,
      note: charge?.note,
      memoPopupOpen: true,
      anchorEl: null
    });
  }

  public renderChargeMemoIcon = (charge: ChargeInterface) => {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span>
          <span data-tip={this.getTipText(charge?.note)}>
            <div className={`icon ${charge?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(charge);
              }}
            >
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  }

  public renderCharge = (charge: ChargeInterface) => {
    return (
      <TableRow
        hover
        key={`charge-${charge.id}`}
        className={`clickable-entity key-charge`}
        onClick={() => {
          this.redirect(`/app/charge/update/${charge.id}`);
        }}
      >
        <TableCell>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div className="icon icon-ic-charge" style={{ color: charge.getIconColor(), marginTop: "4px" }}></div>
          </div>
        </TableCell>

        <TableCell colSpan={2} style={{ width: "65%", paddingLeft: "22px" }}>
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
            <span style={{ display: "inline-block", minWidth: "100px" }}>{this.formatter.formatDate(charge.orderDate)}</span>
            {this.props.invoices === true && ( <span style={{ display: "inline-block", minWidth: "100px" }}>{charge.invoiceNumber}</span>)}
            <div style={{ display: "inline-flex", flexDirection: "column" }}>
              <div style={{ display: "flex", justifyContent: "flex-start" }}>
                {charge?.name || ""}
                {charge.creationTypeDisplayName && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "2px 0px 0px 5px"
                    }}
                  >
                    <div className="list-label creation-type-label">
                      {charge.creationTypeDisplayName}
                    </div>
                  </div>
                )}
              </div>
              <span style={{ fontSize: "12px", color: "gray" }}>
                {`${charge && charge.description === "" ? Formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system) + "," + Formatter.monthFullFormatDate(charge.firstDate) : charge.description} ${!!charge.relatedEntity ? "- " + charge.relatedEntity.displayName : ""}`}
              </span>
            </div>
          </div>
        </TableCell>

        <TableCell style={{ width: "10%" }}>
          {this.renderChargeMemoIcon(charge)}
        </TableCell>
        <TableCell style={{ textAlign: "right", width: "35%" }}>
          {
            <div style={{ display: "inline-flex", flexDirection: "column" }}>
              <span>{charge.chargeClass.id == ChargeClassContainer.pickIdFromLabel("Payable") && charge?.amount > 0 && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(charge.amount, charge.currency)}</span>
              {this.renderChargeAmountHint(charge)}
            </div>
          }
        </TableCell>
        <TableCell
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div>
            <IconButton
              onClick={e => this.openMenu(e, charge)}
            >
              <div className="icon icon-ic-more-vert"></div>
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl) && this.selectedCharge && this.selectedCharge.id === charge.id}
              onClose={this.closeMenu}
              disableAutoFocusItem={true}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left"
              }}
              getContentAnchorEl={null}
            >
              <MenuItem
                onClick={() => {
                  return this.redirect(`/app/charge/update/${this.selectedCharge.id}`);
                }}
              >
                <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                <ListItemText>{this.trans("menuitem-open")}</ListItemText>
              </MenuItem>

              <MenuItem
                key={`add-task-btn`}
                onClick={() => {
                  this.setState({
                    isNewTaskPopupOpen: true,
                    anchorEl: null
                  })
                }
                }
              >
                <ListItemIcon><div className="icon icon-ic-task icon-style-launch-panel"></div></ListItemIcon>
                <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
              </MenuItem>

              <MenuItem
                key={`add-memo-btn`}
                onClick={() => this.openMemoPopup(this.selectedCharge)}
              >
                <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
              </MenuItem>

              {this.props.deleteCharge && (
                <MenuItem
                  onClick={() => this.setState({ charge: this.selectedCharge, isChargeUlinkPopupOpen: true, anchorEl: null })}
                >
                  <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                  <ListItemText>{this.trans("menu/charge-option/remove")}</ListItemText>
                </MenuItem>)}
            </Menu>
          </div>
        </TableCell>
      </TableRow>
    );
  }

  public getContractBalance = () => {
    const chargesForContract = [];


    this.state.unitCombinedContracts.reverse().map(contract => {
      return this.props.relatedContractsBalanceCharges.filter(charge => charge.contractId === contract.id && charge.removed === false)
    })
      .forEach(charges => {
        let currentContract = null;

        const chargesRows = charges
          .filter((charge: ChargeInterface) => !!charge && charge.removed === false)
          .map((charge: ChargeInterface) => {
            currentContract = this.props.app.contracts.find(contract => contract.id === charge.contractId);

            return this.renderCharge(charge);
          });

        if (currentContract && currentContract.nextContractId) {
          chargesForContract.push(
            <TableRow hover key={chargesForContract.length}>
              <TableCell style={{ width: "24px", paddingLeft: "10px", paddingRight: "5px" }}></TableCell>
              <TableCell colSpan={2} style={{ width: "35%" }}>
                {`${this.trans("section/balance-info/renewdate")}: ${this.formatter.formatDate(Time.momentify(currentContract.endDate).add(1, "days"))}`}
              </TableCell>
              <TableCell style={{ width: "80px" }}></TableCell>
              <TableCell style={{ textAlign: "right" }}></TableCell>
              {/* <TableCell style={{ textAlign: "right", width: "15%" }}></TableCell> */}
              <TableCell></TableCell>
            </TableRow>
          );
        }

        chargesForContract.push(chargesRows);
      });

    return chargesForContract.reduce((acc, val) => acc.concat(val), []);
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    }, () => {
      // if (this.state.filter === "all") {
      //   this.fetchFirstAllCharges();
      // } else {
      //   this.fetchFirstUnpaidCharges();
      // }
    });
  }

  public changeAmountForPayment = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      amountForPayment: amount,
      hasModifiedData: true,
    });
  }

  public getContractBalanceRows = (contracts) => {
    const chargesForContract = [];

    contracts.map(contract => {
      return this.props.relatedContractsBalanceCharges.filter(charge => charge.contractId === contract.id && charge.removed === false)
    })
      .forEach(charges => {
        const chargesRows = charges
          .filter((charge: ChargeInterface) => !!charge && charge.removed === false)
          .map((charge: ChargeInterface) => {
            return charge;
          });

        chargesRows.forEach(chargeRow => chargesForContract.push(chargeRow));
      });

    return chargesForContract;
  }

  public getChargesBalance = () => {
    return this.state.balanceCharges
      .filter((charge: ChargeInterface) => !!charge && charge.removed === false)
      .map((charge: ChargeInterface) => {
        return this.renderCharge(charge);
      });
  }

  public getChargesBalanceRows = (charges) => {
    return charges
      .filter((charge: ChargeInterface) => !!charge && charge.removed === false)
      .map((charge: ChargeInterface) => {
        return charge;
      });
  }

  public render() {
    return (
      <div>
        <TableComponent
          {...this.props}
          paginator={{
            name: this.balancePaginatorPath,
            path: this.props.app.paginator
          }}
          className="listing-table balance-charges-table"
          subtitle={this.props.contract && this.props.contract.firstDate < this.props.app.settings.agency.financialStartDate && this.props.app.settings.agency.financialStartDate ? this.trans("section/balance-info/chargesbeforestartdatenotpresented", { startDate: this.formatter.formatDate(this.props.app.settings.agency.financialStartDate) }) : this.trans(`section/balance-info/chargesfor${this.props.balanceFor}notfound`)}
          rows={this.state.unitCombinedContracts ? this.getContractBalance().slice(0, this.state.slice) : this.getChargesBalance().slice(0, this.state.slice)}
        />
        <div style={{ marginBottom: "20px" }}>
          {(this.state.unitCombinedContracts ? this.getContractBalance().length > this.state.slice : this.getChargesBalance().length > this.state.slice) && (
            <div>
              <Button
                color="primary"
                onClick={this.showMore}
                style={{ width: "100%" }}
              >
                {this.trans("section/balance-button/showmore")}
              </Button>
            </div>
          )}
          {/* {(this.state.unitCombinedContracts ?
              (this.getContractBalance().length === this.state.slice)  && (this.getContractBalance().length !== 0 && this.state.slice !== 0)
              :
              (this.getChargesBalance().length === this.state.slice) && (this.getChargesBalance().length !== 0 && this.state.slice !== 0) ) && (
            <div className="load-more-button">
              <Button
                color="primary"
                onClick={this.showLess}
                style={{width: "100%"}}
              >
                {this.trans("section/balance-button/showless")}
              </Button>
            </div>
          )} */}
        </div>
        <DeleteEntityPrompt
          {...this.props}
          entityName={"section/balance-dialog/preprocess-info/deletecharge"}
          isOpen={this.state.isChargeUlinkPopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"section/balance-dialog/preprocess-info/unsettlecharge"}
          isOpen={this.state.isChargeUnSettlePopupOpen}
          onCancel={() => {
            this.setState({
              isChargeUnSettlePopupOpen: false,
            })
          }}
          onDelete={this.unSettle}
          type="button-unsettle"
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsChargeDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({ cannotDeleteSavingsChargeDialog: false })}
          onlyPositiveButton={true}
        />

        <CreateTaskDialog
          {...this.props}
          entity={this.selectedCharge}
          isOpen={this.state.isNewTaskPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false,
              anchorEl: null
            })
          }}
        />

        <QuickPaymentDialog
          {...this.props}
          charge={this.selectedCharge}
          isOpen={this.state.isPayChargePopupOpen}

          initializePage={() => {
            this.setState({
              hasModifiedData: false,
              isPayChargePopupOpen: false
            }, () => {
              this.setState({ isPayChargePopupOpen: false, isSaving: false }, () => this.props.fetchCharges())
            })
          }}

          closeDialog={() => {
            this.setState({
              isPayChargePopupOpen: false,
              isSaving: false,
              anchorEl: null,
            })
          }}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"section/balance-dialog/preprocess-info/unsettlecharge"}
          isOpen={this.state.isChargeUnSettlePopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.unSettle}
          type="button-unsettle"
        />

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo
                {...this.props}
                relations={{ chargeId: this.state.chargeToAddNote?.id }}
                fetchEntities={() => {
                  this.props.dispatch({
                    type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
                  });

                  if (typeof this.props.fetchCharges === "function") {
                    this.props.fetchCharges();
                  }
                }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({ memoPopupOpen: false })}
          hideCross={true}
          subtitle={this.state.chargeToAddNote && this.state.chargeToAddNote.displayName ?
            this.state.chargeToAddNote.displayName : ""}
        />
      </div>
    );
  }
}

export { BalanceComponent };
